import { Component, Inject, inject } from '@angular/core';
import {
    MAT_SNACK_BAR_DATA,
    MatSnackBarRef,
} from '@angular/material/snack-bar';

@Component({
    selector: 'app-failure-snack-bar',
    templateUrl: './failure-snack-bar.component.html',
    host: {
        class: 'flex flex-row items-center',
    },
})
export class FailureSnackBarComponent {
    constructor(
        public snackBarRef: MatSnackBarRef<FailureSnackBarComponent>,
        @Inject(MAT_SNACK_BAR_DATA) public data: any
    ) {}
}
